import React from "reactn";
import "./RequestInfo.css";
import axios from "axios";
import { withRouter } from "react-router-dom";
import { toast } from "react-toastify";
import { ModalTemplate, ModalFields } from "../UI/modalComponents";
import BaseModal from "./baseModal/BaseModal";
import {
  STRING_INPUT,
  DATE_PICKER,
  ITEM_CONTENT,
  TITLE
} from "./baseModal/FieldTypes";
import { BLUE_BUTTON, WHITE } from "./baseModal/colours";
import { color0, color1, color2, color3, color4 } from "../../assets";
class EditReminderModal extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      description: "",
      color: 0,
      date: null
    };

    this.color_choices = [
      { name: "color0", image: color0 },
      { name: "color1", image: color1 },
      { name: "color2", image: color2 },
      { name: "color3", image: color3 },
      { name: "color4", image: color4 }
    ];
  }

  requestTour = async e => {
    e.preventDefault();
  };

  getColor(name) {
    return this.color_choices.filter(img => img.name === name)[0].image;
  }

  async componentDidMount() {
    if (this.props.item) {
      this.setState({
        id: this.props.item.id,
        description: this.props.item.description,
        date: new Date(this.props.item.date),
        color: this.props.item.color
      });
    }
  }

  async addReminder(e) {
    e.preventDefault();
    const reminderEp = `${process.env.REACT_APP_API}/partners/reminders/edit`;
    const updatedReminder = await axios.put(reminderEp, {
      ...this.state
    });

    if (updatedReminder.data.success) {
      toast.success(`Reminder Saved`);
      this.props.reminder(updatedReminder.data.data);
      this.props.onClose();
    }
  }

  /// ================== NEW MODAL ========================== ///

  getBaseModalFields() {
    const descriptionInput = {
      type: STRING_INPUT,
      data: {
        name: "Reminder",
        required: true,
        placeholder: "Reminder Description...",
        handleChange: e => {
          this.setState({
            description: e.target.value
          });
        },
        value: this.state.description
      },
      validators: { validateSubmit: () => this.state.description !== "" }
    };

    const dueField = {
      type: DATE_PICKER,
      data: {
        name: "Due Date",
        required: false,
        selected: new Date(this.state.date),
        handleChange: date => this.setState({ date: date }),
        minDate: new Date(),
        dateFormat: "MMMM d, yyyy",
        placeholder: "Pick a date",
        value: this.state.date
      }
    };

    const colorSelections = {
      type: ITEM_CONTENT,
      data: {
        name: "Color",
        handleChange: value => {
          this.setState({ color: value }, () => console.log("value", value));
        },
        content: [
          { src: this.getColor("color0"), content: "", value: 0 },
          { src: this.getColor("color1"), content: "", value: 1 },
          { src: this.getColor("color2"), content: "", value: 2 },
          { src: this.getColor("color3"), content: "", value: 3 },
          { src: this.getColor("color4"), content: "", value: 4 }
        ]
      }
    };

    return [descriptionInput, dueField, colorSelections];
  }

  getNotAllowedFields = () => {
    const textField = {
      type: TITLE,
      data: {
        name: "Sorry, you may not edit this reminder."
      }
    }
    
    return [textField];
  }

  getBaseModalButtons = () => {
    const editButton = {
      name: "Edit",
      buttonColour: BLUE_BUTTON,
      textColour: WHITE,
      validatorKey: "validateSubmit",
      handleClick: e => this.addReminder(e)
    };

    return [editButton];
  };

  getBaseModalProps = () => {
    return {
      title: "Edit Reminder",
      fields: this.getBaseModalFields(),
      buttons: this.getBaseModalButtons(),
      height: "65vh",
      midSectionHeight: "49vh",
      handleClose: this.props.onClose
    };
  };

  getNotAllowedProps = () => {
    return {
      title: "Edit Reminder",
      fields: this.getNotAllowedFields(),
      height: "65vh",
      midSectionHeight: "49vh",
      handleClose: this.props.onClose
    };
  };

  /// ================== END NEW MODAL ===================== ///

  render() {
    if (this.props.notAllowed) {
      return <BaseModal {...this.getNotAllowedProps()} />;
    } else {
      return <BaseModal {...this.getBaseModalProps()} />;
    }
  }
}

export default withRouter(EditReminderModal);
